import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setLanguage } from '@cmsgov/ds-healthcare-gov';
import { I18nextProvider } from 'react-i18next';
import loadi18n from './locale/i18n';
import App from './components/App';
import { getLanguageFromHost } from './utilities/getLanguageFromHost';
import { initializeNewRelic } from './utilities/newrelic';

import '@cmsgov/ds-healthcare-gov/css/index.css';
import '@cmsgov/ds-healthcare-gov/css/healthcare-theme.css';
import './index.css';

initializeNewRelic();

const locale = getLanguageFromHost();
// set lang on <html>
document.documentElement.lang = locale;
// From design system,
// see: https://design.cms.gov/guidelines/i18n#default-internationalized-content-in-the-design-system
setLanguage(locale);
const i18n = loadi18n();

document.title = i18n.t('estimatorPageTitle');

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>
);
